import Utils from "../utils/utils";
import { icAsset } from "./image/image-src";

export const FaqCard = (faq: { question: string; answer: string }) => {
  const toggleContent = ($event: React.MouseEvent<HTMLButtonElement>) => {
    const content =
      $event.currentTarget.parentElement?.parentElement?.querySelector(
        ".content",
      ) as HTMLElement;
    const contentWrapper =
      $event.currentTarget.parentElement?.parentElement?.querySelector(
        ".content-wrapper",
      ) as HTMLElement;
    if (content && contentWrapper) {
      const isHidden =
        contentWrapper.style.maxHeight === "0px" ||
        contentWrapper.style.maxHeight === "";
      contentWrapper.style.transition = "max-height 0.3s ease-in-out";

      if (isHidden) {
        contentWrapper.style.maxHeight = content.scrollHeight + "px";
        contentWrapper.style.overflow = "visible";
      } else {
        contentWrapper.style.maxHeight = "0px";
        contentWrapper.style.overflow = "hidden";
      }
      $event.currentTarget.classList.toggle("bg-[#A8C6FF]");
      $event.currentTarget.classList.toggle("text-white");
      $event.currentTarget.innerHTML = isHidden
        ? '<div class="border border-white w-2 mx-auto"></div>'
        : `<img class="min-w-[1.3125rem] h-[1.3125rem] mx-auto" src="${icAsset("../../../assets/icons/plus-black.svg")}" alt="" />`;
    }
  };
  return (
    <div className="w-full overflow-hidden rounded-[1rem] bg-white p-4 transition-all [box-shadow:0px_1px_12px_0px_#00000014] sm:p-[1.5rem] sm:px-4 sm:py-2">
      <div className="flex justify-between transition-all">
        <div className="mr-3 flex items-center gap-4 text-[#1A2B48] transition-all">
          <span className="font-normal text-[#232323]">{faq.question}</span>
        </div>
        <button
          type="button"
          onClick={toggleContent}
          className="h-[1.75rem] w-[1.75rem] items-center rounded-full transition-all"
        >
          <img
            className="mx-auto size-4"
            src={icAsset("../../../assets/icons/plus-black.svg")}
            alt=""
          />
        </button>
      </div>
      <div
        className="content-wrapper overflow-hidden transition-all"
        style={{ maxHeight: "0px" }}
      >
        <div
          className="content mt-[0.625rem] text-sm font-normal leading-[1.625rem]"
          dangerouslySetInnerHTML={Utils.createMarkup(faq.answer)}
        />
      </div>
    </div>
  );
};
